import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';
import ThemeToggle from './ThemeToggle';

function Navbar() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isMobileScreen, setIsMobileScreen] = useState(false);

    useEffect(() => {
        const checkScreenWidth = () => {
            setIsMobileScreen(window.innerWidth <= 768);
        };

        checkScreenWidth();
        window.addEventListener('resize', checkScreenWidth);
        return () => window.removeEventListener('resize', checkScreenWidth);
    }, []);

    const handleMobileMenuToggle = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <nav>
            <div className="logo">
                <a href="/">
                    <img src="/images/eupraxia-logo-transparent.png" alt="Eupraxia Labs Logo" />
                </a>
            </div>
            <div className="nav-controls">
                <ThemeToggle />
            </div>
            {isMobileScreen && (
                <div className={`menu-icon ${isMobileMenuOpen ? 'active' : ''}`} onClick={handleMobileMenuToggle}>
                    &#9776;
                </div>
            )}
            <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
                <li className="mainNavLink submenu-parent">
                    <NavLink to="/products" className="mainNavLinkText">Products</NavLink>
                    <ul className="submenu">
                        <li><NavLink to="/fkp" className="subLinkText">Federal Frontier Kubernetes</NavLink></li>
                        <li><NavLink to="/vitro" className="subLinkText">Managed Openstack</NavLink></li>
                        <li><NavLink to="/fedstryke" className="subLinkText">Fedstryke</NavLink></li>
                        {/*<li><NavLink to="/outpostai" className="subLinkText">OutpostAI (F3Iai)</NavLink></li>*/}
                        <li><NavLink to="/private-sector" className="subLinkText">Private Sector Solutions</NavLink></li>
                        <li><NavLink to="/frontier-edge" className="subLinkText">Frontier FleetEdge</NavLink></li>
                    </ul>
                </li>
                <li className="mainNavLink"><NavLink to="/day2apps" className="mainNavLinkText">Day 2 Apps</NavLink></li>
                <li className="mainNavLink"><NavLink to="/about" className="mainNavLinkText">About</NavLink></li>
                <li className="mainNavLink"><NavLink to="/team" className="mainNavLinkText">Team</NavLink> </li>
                <li className="mainNavLink"><NavLink to="/contact" className="mainNavLinkText">Contact</NavLink></li>
            </ul>
        </nav>
    );
}

export default Navbar;